export default {
  newLineTitle: 'Nueva línea de factura',
  tableActionText: 'Pulse "Añadir" para agregar un nuevo elemento',
  title: 'Detalles de la factura',
  confirmDeleteLine: 'Al eliminar línea perderá la información introducida. ¿Desea eliminarla?',
  deleteLine: 'Eliminar línea',
  noData: 'No hay datos disponibles',
  headers: {
    description: 'Descripción',
    quantity: 'Cantidad',
    amount: 'Importe',
    rebate: 'Des/Cargos',
    taxes: 'Impuestos',
    subtotal: 'Subtotal',
    type: 'Tipo',
    class: 'Clase',
    percent: '(%)',
    taxType: 'Tipo Impuesto',
    documentType: 'Tipo Documento',
    datum: 'Dato',
    reason: 'Motivo'
  },
  form: {
    actionText: '(Artículos 14, 143 de la ley 37/1992, del IVA)',
    articleData: {
      title: 'Datos del artículo',
      vendorCode: 'Código vendedor',
      payerCode: 'Código pagador',
      description: 'Descripción',
      priceBatch: 'Precio por lote',
      quantity: 'Cantidad',
      unit: 'Unidad',
      batchUnits: 'Unidades por lote',
      search: 'Buscar en catálogo',
      tooltip: 'Campo obligatorio si se va a enviar datos inmovilizados'
    },
    resume: {
      title: 'Resumen de cantidades',
      totalBefore: 'Total antes de descuentos/cargos',
      totalDiscountsCharges: 'Total descuentos/cargos',
      totalTaxes: 'Total impuestos',
      totalLine: 'Total línea'
    },
    discountsCharges: {
      title: 'Descuentos/Cargos',
      validation: 'Los campos para el cáculo del importe no son válidos, revise los valores de Precio por lote, Cantidad o Unidades por lote.'
    },
    taxes: {
      title: 'Impuestos'
    },
    documents: {
      title: 'Documentos asociados',
      orderSender: 'Nº pedido emisor',
      orderReceiver: 'Nº pedido receptor'
    },
    deliveryNotes: {
      title: 'Albaranes',
      validation: 'El campo \'Dato \' debe ser alfanumérico.'
    },
    extraInfo: {
      title: 'Información adicional',
      comments: 'Observaciones',
      itemStartDate: 'Fecha inicio',
      itemEndDate: 'Fecha fin'
    },
    serisMandatori: 'Campos obligatorios para facturas emitidas al servicio riojano de Salud (SERIS)'
  }
}
